module.exports = __webpack_public_path__ + "ff72b1b73e9f17d7554877c436a6b957.svg";